import { Button, Form, Input } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useEffect } from "react";
import {
  EditOutlined,
  PlusOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { FormInstance } from "antd";
import ButtonWrapper from "../../../components/reuseComp/ButtonWrapper";

const RelevantIndustries: React.FC<{
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: FormInstance;
  relevantIndustriesdata?: {
    heading: string;
    subtext: string;
    points: string[];
  };
  loading: boolean;
}> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  relevantIndustriesdata,
  loading,
}) => {
  useEffect(() => {
    if (relevantIndustriesdata) {
      form.setFieldsValue({
        relevantIndustries: {
          heading: relevantIndustriesdata?.heading || "",
          subtext: relevantIndustriesdata?.subtext || "",
          points:
            relevantIndustriesdata.points &&
            relevantIndustriesdata.points.length > 0
              ? relevantIndustriesdata.points
              : [""],
        },
      });
    }
  }, [relevantIndustriesdata, form]);
  return (
    <>
      {isEditing ? (
        <div>
          <div className="bg-[#F9F9F9] p-3 sm:p-6 rounded-lg sm:rounded-2xl shadow-sm">
            <Form
              layout="vertical"
              form={form}
              initialValues={{ relevantIndustries: { points: [""] } }}
            >
              <Form.Item
                label="Heading"
                name={["relevantIndustries", "heading"]}
                rules={[{ required: true, message: "please enter heading" }]}
              >
                <Input placeholder="enter heading..." />
              </Form.Item>
              <Form.Item
                label="Subtext"
                name={["relevantIndustries", "subtext"]}
                rules={[{ required: true, message: "please enter subtext" }]}
              >
                <TextArea rows={3} placeholder="enter subtext..." />
              </Form.Item>
              <Form.Item label="Points" className="sm:col-span-2">
                <Form.List name={["relevantIndustries", "points"]}>
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name }) => (
                        <div key={key} className="flex gap-2 items-center mb-2">
                          <Form.Item
                            name={name}
                            rules={[
                              { required: true, message: "Enter content" },
                            ]}
                            className="flex-1 mb-0"
                          >
                            <Input placeholder="enter points..." />
                          </Form.Item>
                          <MinusCircleOutlined
                            className="text-red-500 text-lg cursor-pointer"
                            onClick={() => remove(name)}
                          />
                        </div>
                      ))}
                      <Button
                        type="dashed"
                        onClick={() => add("")}
                        icon={<PlusOutlined />}
                        className="mt-2"
                      >
                        Add point
                      </Button>
                    </>
                  )}
                </Form.List>
              </Form.Item>
            </Form>
          </div>
          <div className="flex justify-start gap-3 mt-7 sticky bottom-5">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>
            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      ) : (
        <>
          <div className="rounded-[20px] overflow-hidden">
            <table className="overflow-x-auto hidden min-w-full sm:table">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 text-xs md:text-base px-4 text-left">
                    {" "}
                    Heading
                  </th>
                  <th className="py-3 text-xs md:text-base px-4 text-left">
                    Subtext
                  </th>
                  <th className="py-3 text-xs md:text-base px-4 text-left">
                    Points
                  </th>
                  <th className="py-3 text-xs md:text-base px-4 text-left">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {relevantIndustriesdata?.heading ||
                relevantIndustriesdata?.subtext ? (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td className="py-3 px-4 text-gray-700">
                      {relevantIndustriesdata?.heading}
                    </td>
                    <td className="py-3 px-4 text-gray-700">
                      {relevantIndustriesdata?.subtext}
                    </td>
                    <td className="py-3 px-4 text-gray-700">
                      <p className="line-clamp-1">
                        {relevantIndustriesdata?.points
                          ?.slice(0, 2)
                          .join(", ") || "-"}
                      </p>
                    </td>
                    <td className="py-3 px-4">
                      <EditOutlined
                        onClick={() => setIsEditing(true)}
                        className="cursor-pointer text-primary text-[20px]"
                      />
                    </td>
                  </tr>
                ) : (
                  <>
                    <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                      <td
                        colSpan={4}
                        className="text-center py-6 text-gray-500 "
                      >
                        <Button
                          type="dashed"
                          onClick={() => setIsEditing(true)}
                        >
                          Add data
                        </Button>
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>

            <table className="min-w-full border-collapse table sm:hidden">
              <tbody>
                {relevantIndustriesdata ? (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8] sm:table-row block mb-4 sm:mb-0 rounded-lg sm:rounded-none shadow-sm sm:shadow-none">
                    <td className="py-2 px-4 block sm:table-cell">
                      <div>
                        <b className="text-primary">Heading:</b>
                      </div>
                      <p className="">{relevantIndustriesdata?.heading}</p>
                    </td>
                    <td className="py-2 px-4 block sm:table-cell">
                      <div>
                        <b className="text-primary">Subtext:</b>
                      </div>
                      <p className="line-clamp-3">
                        {relevantIndustriesdata?.subtext}
                      </p>
                    </td>
                    <td className="py-2 px-4 sm:table-cell">
                      <div>
                        <b className="text-primary">Points:</b>
                      </div>
                      <p className="line-clamp-2">
                        {relevantIndustriesdata?.points
                          ?.slice(0, 2)
                          .join(", ") || "-"}
                      </p>
                    </td>

                    <td className="py-2 px-4 text-primary block sm:table-cell">
                      <div className="flex items-center gap-4">
                        {relevantIndustriesdata ? (
                          <EditOutlined
                            onClick={() => setIsEditing(true)}
                            className="cursor-pointer text-primary text-[20px]"
                          />
                        ) : (
                          <PlusOutlined
                            onClick={() => setIsEditing(true)}
                            className="cursor-pointer text-primary text-[20px]"
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr className="bg-[#F9F9F9] border-2  border-[#e9e8e8]">
                    <td colSpan={5} className="text-center py-6 text-gray-500 ">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
};

export default RelevantIndustries;
